import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import GenderService from "../../../Services/Gender.service";
const makeSearchArgs = {
    loadOptions: (search) => GenderService.searchAll(search),
    label: "name",
    value: "id",
};
export const GenderSearch = makeSearch(makeSearchArgs);
export const GenderMultiSearch = makeMultiSearch(Object.assign({}, makeSearchArgs));
